var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import * as Prism from 'prismjs';
import 'prismjs/components/prism-json';
// @ts-ignore
import prismTheme from 'prismjs/themes/prism-solarizedlight.css?inline';
import { localized, msg } from '@lit/localize';
let JsonDisplayer = class JsonDisplayer extends LitElement {
    constructor() {
        super(...arguments);
        this.data = null;
        this.highlighted = '';
    }
    updated(changed) {
        if (changed.has('data')) {
            this.updateHighlightedCode();
        }
    }
    updateHighlightedCode() {
        const jsonStr = this.data ? JSON.stringify(this.data, null, 2) : '';
        this.highlighted = Prism.highlight(jsonStr || ' ', Prism.languages.json, 'json');
    }
    render() {
        this.updateHighlightedCode();
        if (!this.data) {
            return html `
        <basic-card>
          <p>${msg('No data available', { id: 'jsonDisplayer.noData', desc: 'No data available message', })}</p>
        </basic-card>
      `;
        }
        return html `
      <basic-card>
        <pre><code class="language-json" .innerHTML=${this.highlighted}></code></pre>
      </basic-card>
    `;
    }
};
JsonDisplayer.styles = [css `
    :host {
      display: block;
      font-family: 'Fira Code', monospace;
    }
    pre[class*="language-"] {
      color: #586e75;
      background: none;
    }
    code[class*="language-"] {
      color: #586e75;
      background: none;
    }
  `, unsafeCSS(prismTheme)];
__decorate([
    property({ type: Object })
], JsonDisplayer.prototype, "data", void 0);
JsonDisplayer = __decorate([
    localized(),
    customElement('json-displayer')
], JsonDisplayer);
export { JsonDisplayer };
//# sourceMappingURL=JsonDisplayer.js.map